import { useTranslation } from 'react-i18next';
import { useUIStore } from '@/core/stores/ui.store';
import { getPanelConfig } from '@/shared/config/panel.config';

export function PanelContent() {
  const { t } = useTranslation('layout');
  const activePanelId = useUIStore((s) => s.activePanelId);
  const panelConfig = getPanelConfig(activePanelId);

  return (
    <div className="flex-1 overflow-y-auto p-4">
      <div className="flex flex-col items-center justify-center h-full min-h-[200px]">
        <p className="text-sm text-muted-foreground font-medium">
          {panelConfig?.labelKey ? t(panelConfig.labelKey) : activePanelId}
        </p>
        <p className="text-xs text-muted-foreground/60 mt-2">Panel en desarrollo</p>
      </div>
    </div>
  );
}
